import { useTranslation } from 'react-i18next'

import { Card, CardTitle, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const AdditionalReturnedProductsCardSkeleton = () => {
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle marginBottom="0">{t('Productos devueltos adicionales')}</CardTitle>
      <Styles.ItemsContainer>
        <Styles.ProductRow>
          <Skeleton variant="rounded" width={88} height={88} />
          <Styles.ProductInfo>
            <Skeleton variant="text" width={140} height={20} />
            <Skeleton variant="text" width={100} height={14} />
            <Skeleton variant="text" width={70} height={20} />
          </Styles.ProductInfo>
        </Styles.ProductRow>
      </Styles.ItemsContainer>
      <Skeleton variant="rounded" width="100%" height={48} />
    </Card>
  )
}

export default AdditionalReturnedProductsCardSkeleton
